import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetCashbackTransactions = gql`
  query GetCashbackTransactionDetails {
    myPartnerOffers {
      cashback {
        currentBalance {
          ...money
        }
        earningsUpToDate {
          ...money
        }
        transactions {
          edges {
            node {
              id
              merchantId
              cashbackStatus
              transactionDate
              title
              cashbackAmount {
                ...money
              }
              value {
                ...money
              }
              direction
              description
              status
              category
              method
              iconUrl
              isCashbackTransaction
              details {
                title
                items {
                  key
                  title
                  description
                  value
                }
              }
            }
          }
        }
      }
    }
  }
  ${money}
`;

export default GetCashbackTransactions;
